module.exports = "<button class=\"stateful-button-wrapper\">\r\n  <div class=\"front\" ng-class=\"statefulButton.defs.style\">\r\n    <div class=\"stateful-button-inner-content\">\r\n      {{statefulButton.defs.label}}\r\n    </div>\r\n  </div>\r\n  <div class=\"back\" ng-class=\"statefulButton.style\">\r\n    <div class=\"stateful-button-inner-content\">\r\n      <span>{{statefulButton.label}}</span>\r\n      <ion-spinner icon=\"dots\" ng-show=\"statefulButton.isWorking()\"></ion-spinner>\r\n    </div>\r\n  </div>\r\n</button>";


//////////////////
// WEBPACK FOOTER
// ./src/js/core-components/transforming-buttons/stateful-button.html
// module id = 2951
// module chunks = 0